import styled from 'styled-components'

export const PublicAdministrationFilterPanelRoot = styled.div<{ $alignToFilterBarRight: boolean }>`
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 400px;
  width: 320px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.12);
  padding: 24px;
  position: absolute;
  z-index: 1000;
  margin-top: 8px;
  ${props =>
    props.$alignToFilterBarRight
      ? `
    right: 0;
    top: 100%;
    left: auto;
  `
      : `
    left: 0;
    top: 100%;
  `}
`

export const PublicAdministrationFilterPanelHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 16px;
`

export const PublicAdministrationFilterPanelTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #0066b3;
  flex: 1;
`

export const PublicAdministrationFilterPanelClearAll = styled.span`
  color: #0066b3;
  font-weight: 400;
  font-size: 14px;
  text-decoration: underline;
  cursor: pointer;
  user-select: none;
  margin-left: 12px;
`

export const PublicAdministrationFilterGroupHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`

export const PublicAdministrationFilterGroupTitle = styled.span`
  color: #464646;
  font-weight: 500;
  font-size: 16px;
  flex: 1;
`

export const PublicAdministrationFilterGroupClear = styled.span`
  color: #0066b3;
  font-weight: 400;
  font-size: 14px;
  text-decoration: underline;
  cursor: pointer;
  user-select: none;
  margin-left: 12px;
`

export const PublicAdministrationFilterDivider = styled.div`
  border-bottom: 1px solid #eee;
  margin: 12px 0;
`

export const PublicAdministrationFilterCheckboxList = styled.div`
  margin-bottom: 16px;
`

export const PublicAdministrationFilterCheckboxRow = styled.div`
  margin-bottom: 8px;
`
